export default __webpack_public_path__ + "static/media/travolta-crunched.5fb35426.gif";